import claim from 'Agent/Claims/ducks/claim';

export default {
  claim,
};
